import { render, staticRenderFns } from "./StaffOnlyTag.vue?vue&type=template&id=1467858a&scoped=true"
import script from "./StaffOnlyTag.vue?vue&type=script&lang=js"
export * from "./StaffOnlyTag.vue?vue&type=script&lang=js"
import style0 from "./StaffOnlyTag.vue?vue&type=style&index=0&id=1467858a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467858a",
  null
  
)

export default component.exports